import { lazy, Suspense } from 'react';
import { LoadingState } from '../components/LoadingState';

const AdminRoutes = lazy(() => import('./AdminRoutes'));

export function LazyAdminRoutes() {
  return (
    <Suspense fallback={<LoadingState label="Loading the Backyard workspace…" />}>
      <AdminRoutes />
    </Suspense>
  );
}
